import { createZustandStore } from '../../../zustand';
import { DEFAULT_SCAN_TYPE } from '../remove-package';

import { ISwitchPodStoreState } from './type';

/**
 * This creates a local global state for Pods related data management.
 */
export const useSwitchPodsStore = createZustandStore<ISwitchPodStoreState>()(
  (set) => ({
    assetDetails: null,
    updateAssetDetails: (data) => set({ assetDetails: data }),
    selectedPodLocation: undefined,
    updateSelectedPodLocation: (podLocation) =>
      set(() => ({ selectedPodLocation: podLocation })),
    switchPodRemarks: '',
    updateSwitchPodRemarks: (text: string) =>
      set(() => ({ switchPodRemarks: text })),

    transferPodInfo: null,
    updateTransferPodInfo: (transferPodInfo) =>
      set(() => ({ transferPodInfo })),
    transferTrayInfo: null,
    updateTransferTrayInfo: (transferTrayInfo) =>
      set(() => ({ transferTrayInfo })),
    isPackageRemoved: false,
    currentScanStep: 'scanPackage',
    updateCurrentScanStep: (currentScanStep) =>
      set(() => ({ currentScanStep })),
    scanType: DEFAULT_SCAN_TYPE,
    // updateScanType: (scanType) => set(() => ({ scanType })),
    updateScanType: (scanType) => set(() => ({ scanType })),
    suggestedTrayInfo: null,
    updateSuggestedTrayInfo: (suggestedTrayInfo) =>
      set(() => ({ suggestedTrayInfo })),
    isScannerReadingData: false,
    updateIsScannerReadingData: (isScannerReadingData) =>
      set(() => ({ isScannerReadingData })),
    packageIdentifier: '',
    updatePackageIdentifier: (packageIdentifier) =>
      set(() => ({ packageIdentifier })),
    scannedAssetDetails: null,
    updateScannedAssetDetails: (data) =>
      set(() => ({ scannedAssetDetails: data })),
    resetStore: () =>
      set(() => ({
        packageDetails: null,
        transferPodInfo: null,
        transferTrayInfo: null,
        isPackageRemoved: false,
        currentScanStep: 'scanPackage',
        scanType: DEFAULT_SCAN_TYPE,
        isScannerReadingData: false,
        packageIdentifier: '',
      })),
  })
);
